mutation CommunicationChannelDelete($input: CommunicationChannelDeleteInput!) {
  communicationChannelDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
